// extracted by mini-css-extract-plugin
export default {"restrictions":"restrictions_restrictions__UuSNM","restrictions__title":"restrictions_restrictions__title__RryMg"};